import { Deviation } from './vehicle-deviation';

export class VehicleDeparture {
    stopRef: string;
    sequenceNumber: number;
    deviation: Deviation;

    constructor(obj: VehicleDeparture | any = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (typeof obj.deviation === 'string' || obj.deviation instanceof String) {
            this.deviation = new Deviation(obj.deviation);
        }
    }
}
